export default __webpack_public_path__ + "static/media/money.16bc674a.svg";